import { useEffect, useState } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import EquipmentFilterPopOver from "../EquipmentFilterPopOver";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import emailStore from "../../../Stores/EmailNotificationStore";
import EmailConstants from "../../../Constants/EmailNotificationConstants";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import { toast } from "react-toastify";
import commonUtils from "../../../helpers/commonUtils";
import EmailNotificationAction from "../../../Actions/EmailNotificationAction";
import DistributionGroupConfiguration from "./DistributionGroupConfiguration";
import EmailHeader from "./EmailHeader";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import FilterEquipmentList from "./FilterEquipmentList";
import SelectedEquipmentGroups from "./SelectedEquipmentGroups";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import equipmentGroupConstants from "../../../Constants/EquipmentGroupConstants";

export default function EmailSchedular({
  scheduleEmailDetails,
  distributionGroupList,
  viewMode,
  activeTab,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [emailSchedularList, setEmailSchedularList] = useState([]);
  const [fieldValues, setFieldValues] = useState({
    title: "",
    emailType: "DueOrOverdueInspection",
    eqgrpSelected: [],
    startDate: "",
    endDate: "",
  });

  const [filterValue, setFilterValue] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [scheduleEmailID, setScheduleEmailID] = useState(null);
  const [filterList, setFilterList] = useState(null);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [currentFilteringGroupId, setCurrentFilteringGroupId] = useState(null);
  const [isGrpChange, setIsGrpChange] = useState(true);
  const [allEqGrps, setAllEqGrps] = useState([]);

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "Alert_User":
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  useEffect(() => {
    function updateEquipmentGroup() {
      setGlobalSpinner(false);
      const res = equipmentGroupStore.getEquipmentGroupList();
      setAllEqGrps(res);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_EQUIPMENTGROUP_SUCCESS,
      updateEquipmentGroup,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_EQUIPMENTGROUP_SUCCESS,
        updateEquipmentGroup,
      );
    };
  }, []);

  useEffect(() => {
    if (activeTab === 2 && !viewMode) {
      setGlobalSpinner(true);
      EquipmentGroupActions.getEquipmentGroupList(
        sessionStorage.getItem("userid"),
      );
    }
  }, [activeTab]);

  useEffect(() => {
    if (scheduleEmailDetails && !viewMode) {
      setIsEdit(true);
      let groupIds = [];
      const filtersByGroup = {};

      if (
        scheduleEmailDetails.equipmentFilters &&
        scheduleEmailDetails.equipmentFilters.length > 0
      ) {
        // Correctly parse the nested filter structure
        scheduleEmailDetails.equipmentFilters.forEach((groupFilter) => {
          const groupId = groupFilter.equipmentGroupId;
          if (groupId) {
            groupIds.push(groupId);
            filtersByGroup[groupId] =
              groupFilter.filters?.map((f) => ({
                Name: f.filterType,
                Operator: f.operator,
                Value: f.value,
              })) || [];
          }
        });
        setFilterValue(filtersByGroup);
      }

      setFieldValues({
        title: scheduleEmailDetails.subject,
        emailType: scheduleEmailDetails.emailType,
        eqgrpSelected: groupIds,
        startDate: scheduleEmailDetails.startDate,
        endDate: scheduleEmailDetails.endDate,
      });
      setScheduleEmailID(scheduleEmailDetails.id);
      commonUtils.setIsEdit(true);
    } else {
      commonUtils.setIsEdit(false);
    }
  }, [scheduleEmailDetails]);

  useEffect(() => {
    function getEmailSchedularSuccess() {
      var res = emailStore.getResult();
      toast.success(
        commonUtils.edit
          ? localization.schedularEditSucess
          : localization.schedularSaveSucess,
      );
      setGlobalSpinner(false);
    }

    function getEmailSchedularFailure() {
      var res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    emailStore.addChangeListener(
      EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_SUCCESS,
      getEmailSchedularSuccess,
    );

    emailStore.addChangeListener(
      EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_FAILURE,
      getEmailSchedularFailure,
    );

    return () => {
      emailStore.removeChangeListener(
        EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_SUCCESS,
        getEmailSchedularSuccess,
      );

      emailStore.removeChangeListener(
        EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_FAILURE,
        getEmailSchedularFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getEquipmetGrpAttributeSuccess() {
      var res = emailStore.getResult();
      if (res.length > 0) {
        if (scheduleEmailDetails) {
        }
        setFilterList(res);
        setIsFilterVisible(true); // Show popover only after filter list is fetched
      } else {
        setFilterList(null);
      }
      setGlobalSpinner(false);
    }

    function getEquipmetGrpAttributeFailure() {
      const res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    emailStore.addChangeListener(
      EmailConstants.GET_EQIPMENT_FILTER_SUCCESS,
      getEquipmetGrpAttributeSuccess,
    );

    emailStore.addChangeListener(
      EmailConstants.GET_EQIPMENT_FILTER_FAILURE,
      getEquipmetGrpAttributeFailure,
    );

    return () => {
      emailStore.removeChangeListener(
        EmailConstants.GET_EQIPMENT_FILTER_SUCCESS,
        getEquipmetGrpAttributeSuccess,
      );

      emailStore.removeChangeListener(
        EmailConstants.GET_EQIPMENT_FILTER_FAILURE,
        getEquipmetGrpAttributeFailure,
      );
    };
  }, []);

  useEffect(() => {
    if (filterValue[currentFilteringGroupId]?.length > 0) {
      setIsGrpChange(false);
    } else {
      setIsGrpChange(true);
    }
  }, [filterValue, currentFilteringGroupId]);

  function handleSchedularSave(event) {
    event.preventDefault();

    if (fieldValues.eqgrpSelected.length === 0) {
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(localization.pleaseSelectEqpGrp);
      setEventType("Alert_User");
      return;
    }

    let _temp = [];
    emailSchedularList.map((item) => {
      if (item.checked) {
        _temp.push({
          EmailDistributionGroupId: item.id,
          IsBefore: item.type === "before" ? true : false,
          Days: parseInt(item.days),
          FrequencyInDays: parseInt(item.frequency),
        });
      }
    });
    if (_temp.length > 0) {
      if (fieldValues.startDate !== "") {
        const equipmentFilters = fieldValues.eqgrpSelected.map((groupId) => {
          const filters = filterValue[groupId] || [];
          return {
            EquipmentGroupId: groupId,
            Filters: filters.map(({ Name, Operator, Value }) => ({
              FilterType: Name,
              Operator: Operator,
              Value: Value,
            })),
          };
        });

        const _payloadValue = {
          Subject: fieldValues.title,
          EmailType: fieldValues.emailType,
          EquipmentFilters: equipmentFilters,
          EmailDistributionGroupInfos: _temp,
          StartDate: fieldValues.startDate,
          EndDate: fieldValues.endDate,
        };
        if (scheduleEmailID !== null) {
          _payloadValue.ID = scheduleEmailID;
        }
        setGlobalSpinner(true);
        EmailNotificationAction.saveOrupdateEmailSchedule(_payloadValue);
      } else {
        setConfirmationPopUpOpen(true);
        setConfirmationPopUpMsg(localization.consfirmationMsg2);
        setEventType("Alert_User");
      }
    } else {
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(localization.consfirmationMsg1);
      setEventType("Alert_User");
    }
  }

  function getFilterEqList() {
    setGlobalSpinner(true);
    EquipmentGroupActions.getEquipmentList2(
      "EquipList",
      "asc",
      fieldValues.eqgrpSelected[0],
      1,
      20,
      "inventry",
      null,
      filterValue[fieldValues.eqgrpSelected[0]] || [],
    );
  }

  const handleFilterForGroup = (groupId) => {
    setCurrentFilteringGroupId(groupId);
    setGlobalSpinner(true);
    EmailNotificationAction.getEquipmentFilter(groupId);
  };

  const handleSetFilterValue = (newFilters) => {
    setFilterValue((prev) => ({
      ...prev,
      [currentFilteringGroupId]: newFilters,
    }));
  };

  return (
    <>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
        isCancelShow={false}
      />
      <FilterEquipmentList />
      {isFilterVisible && (
        <EquipmentFilterPopOver
          filterList={filterList}
          setFilterValue={handleSetFilterValue}
          setIsFilterVisible={setIsFilterVisible}
          filterValue={filterValue[currentFilteringGroupId] || []}
        />
      )}
      <div className="mt-3">
        {!viewMode && (
          <h2 className="settingPageheader">
            {localization.genSetting + " / " + localization.emailSchedular}
          </h2>
        )}
        <form
          id="configScedhular"
          autoComplete="off"
          onSubmit={handleSchedularSave}
        >
          <div className="container mw-100 emailConfig">
            {!viewMode && (
              <EmailHeader
                fieldValues={fieldValues}
                setFieldValues={setFieldValues}
                setIsFilterVisible={setIsFilterVisible}
                setRenderFilterList={() => {}}
                setFilterList={setFilterList}
                setFilterValue={setFilterValue}
                filterList={filterList}
              />
            )}

            {!viewMode && (
              <SelectedEquipmentGroups
                selectedGroupIds={fieldValues.eqgrpSelected}
                eqGrpList={allEqGrps}
                onFilter={handleFilterForGroup}
                filterValues={filterValue}
              />
            )}

            <DistributionGroupConfiguration
              setList={setEmailSchedularList}
              distributionGroupList={distributionGroupList}
              scheduleEmailDetails={scheduleEmailDetails}
              viewMode={viewMode}
            />
          </div>
          {!viewMode && (
            <div className="row ml-0 mr-0 justify-content-end">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4 float-right emailBtnML"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          )}
        </form>
      </div>
    </>
  );
}
